module.exports = __webpack_public_path__ + "1e39de6d9d3250813a6e1a053954e95f.svg";